import request from "../../utils/request";
import {
    PayslipBrandingView,
    PayslipBrandingInput
} from "../../models/payroll";
import { Result } from "../../models/general";

export async function GetCompanyPayslipBranding() {
    const response = await request.get<Result<PayslipBrandingView | null>>("PayslipBranding/GetCompanyPayslipBranding");
    return response.data;
}

export async function UpsertPayslipBranding(input: PayslipBrandingInput) {
    const response = await request.post<Result<boolean>>("PayslipBranding/UpsertPayslipBranding", input);
    return response.data;
}
